module.exports = __webpack_public_path__ + "img/IT0000249405537.6c8d656b.png";